/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { Group } from '../../core/_models'
import { formatDateTime } from '../../../../../utils/dayJs/format'

type Props = {

    group: Group
}

const UpdatedInCell: FC<Props> = ({ group }) => (

    <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 text-hover-danger mb-1'>
            {group.updatedAt ? formatDateTime(group.updatedAt.toString()) : 'N/A'}
        </a>
    </div>
)

export { UpdatedInCell }
